import Tooltip from '../EditorTopBar/Tooltip';

/**
 * The teal Publish pill, immediately left of the status pill (mock-up 05 §01).
 * It exists only while there is something to publish, and dims only while a
 * save has failed, so the client never gets a copy Henry is not looking at.
 */
export default function PublishButton({
  saveFailed,
  busyRound,
  onClick,
  className = '',
}: {
  saveFailed: boolean;
  /** "Publishing v3" while the request is in flight. */
  busyRound: number | null;
  onClick: () => void;
  className?: string;
}) {
  const busy = busyRound !== null;
  const reason = saveFailed ? 'Retry the save first, so the client gets what you see' : null;
  return (
    <Tooltip content={reason ?? 'Publish your changes to the client'}>
      <button
        type="button"
        onClick={saveFailed || busy ? undefined : onClick}
        aria-disabled={saveFailed || busy || undefined}
        aria-label={reason ? `Publish. ${reason}` : 'Publish'}
        className={`
          inline-flex items-center gap-1.5 h-[30px] pl-2.5 pr-3.5 rounded-full shrink-0 whitespace-nowrap
          bg-accent text-accent-fg border border-accent text-[12.5px] font-semibold
          hover:bg-accent-hover transition-colors duration-150
          focus:outline-none focus-visible:shadow-focus
          aria-disabled:opacity-40 aria-disabled:cursor-not-allowed aria-disabled:hover:bg-accent
          ${busy ? 'bg-accent-hover' : ''} ${className}
        `}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M12 19V5M5 12l7-7 7 7" />
        </svg>
        {busy ? `Publishing v${busyRound}` : 'Publish'}
      </button>
    </Tooltip>
  );
}
